import script from "./aboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./aboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./aboutUs.vue?vue&type=style&index=0&id=0cb5fbe7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb5fbe7"]])

export default __exports__